export interface FormattedData {
  timestamp: number
  dateTime: string
  download: number
  upload: number
}

export const getTicksOfEachNewYears = (data: FormattedData[]) => {
  return data.reduce((acc, curr, index) => {
    if (index === 0) {
      return [curr.timestamp]
    }
    if (
      new Date(curr.timestamp).getFullYear() !==
      new Date(acc[acc.length - 1]).getFullYear()
    ) {
      return [...acc, curr.timestamp]
    }
    return acc
  }, [] as number[])
}

export const getTicksOfEachNewMonths = (data: FormattedData[]) => {
  return data.reduce((acc, curr, index) => {
    if (index === 0) {
      return [curr.timestamp]
    }
    if (
      new Date(curr.timestamp).getMonth() !==
      new Date(acc[acc.length - 1]).getMonth()
    ) {
      return [...acc, curr.timestamp]
    }
    return acc
  }, [] as number[])
}

export const getTicksOfEachNewDays = (data: FormattedData[]) => {
  return data.reduce((acc, curr, index) => {
    if (index === 0) {
      return [curr.timestamp]
    }
    if (
      new Date(curr.timestamp).getDate() !==
      new Date(acc[acc.length - 1]).getDate()
    ) {
      return [...acc, curr.timestamp]
    }
    return acc
  }, [] as number[])
}

export const getTicksOfEachNewHours = (data: FormattedData[]) => {
  return data.reduce((acc, curr, index) => {
    if (index === 0) {
      return [curr.timestamp]
    }
    if (
      new Date(curr.timestamp).getHours() !==
      new Date(acc[acc.length - 1]).getHours()
    ) {
      return [...acc, curr.timestamp]
    }
    return acc
  }, [] as number[])
}
